export default __webpack_public_path__ + "static/media/webNotice.08359c2d.svg";